<style>
  .modal-body-upgrade {
    padding: 0 48px 48px;
    @media (max-width: 767px) {
      padding: 0 24px 24px;
    }
    @media (max-width: 340px) {
      padding: 0 16px 16px;
    }
  }

  .text-commision {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .select-landing-page {
    width: 100px;
    flex: 1;
  }

  .landing-page-buttons {
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
  }

  .copy-tracking,
  .generate-qr {
    width: 40px;
    height: 38px;
    margin-left: 8px;
    background-color: #308de3;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inf-value,
  .inf-value-name {
    margin-left: auto;
    font-weight: 600;
  }

  .inf-value-name {
    max-height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .content-request {
    margin-top: 16px;
    background-color: #f5faff;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #cae5f0;
  }

  .modal-qr-body {
    text-align: center;
    margin-bottom: 28px;
  }

  .text-qr {
    font-size: 16px;
    margin-bottom: 18px;
  }
</style>

<div style="margin-bottom: 24px">
  <a [routerLink]="['/offers']" class="slug" style="cursor: pointer">
    {{ "offers.detail.offers" | translate }} /
  </a>
  <span class="slug act">{{ "offers.detail.detail_offer" | translate }}</span>
</div>

<div class="row">
  <div [class]="!isMobile ? 'd-flex col-md-12' : ''">
    <div [class]="isResponsive ? 'col-md-4' : 'col-md-3'">
      <div #heightCardInfo class="card-info">
        <app-loading *ngIf="loadHistory || loadDetailPage"></app-loading>
        <ng-container *ngIf="!loadDetailPage && !loadHistory">
          <div class="image-are">
            <img
              style="height: 100%; width: 100%; border-radius: 8px"
              [src]="offerImage"
            />
          </div>
          <div class="offer-name" style="margin-top: 16px">
            <span>#</span>
            {{ offerId + " " + offerName }}
          </div>
          <div class="d-flex align-items-end" style="margin-top: 12px">
            <div class="inf-title">
              {{ "offers.detail.commission" | translate }}
            </div>
            <ng-container *ngIf="payoutExclusive; else payoutNotEx">
              <div class="inf-value" style="text-align: end">
                <div
                  style="
                    color: #646464;
                    font-size: 12px;
                    text-decoration: line-through;
                  "
                >
                  {{
                    isNumber(offerPayout)
                      ? (offerPayout | commaConvert)
                      : offerPayout
                  }}
                </div>
                <div class="inf-value" style="color: #308de3">
                  {{
                    isNumber(payoutExclusive)
                      ? (payoutExclusive | commaConvert)
                      : payoutExclusive
                  }}
                </div>
              </div>
            </ng-container>
            <ng-template #payoutNotEx>
              <ng-container>
                <div class="inf-value" style="text-align: end">
                  <div
                    [style]="
                      checkPayoutRegisteredButOff()
                        ? 'color: #646464; font-size: 12px; text-decoration: line-through'
                        : 'color: #308DE3'
                    "
                  >
                    {{
                      isNumber(offerPayout)
                        ? (offerPayout | commaConvert)
                        : offerPayout
                    }}
                  </div>
                </div>
              </ng-container>
            </ng-template>
          </div>
          <div
            class="d-flex"
            style="margin-top: 12px"
            *ngIf="detailOffer?.register_exclusive == true"
          >
            <div class="inf-title" style="text-align: start">
              {{ "offers.detail.upgrade_offer" | translate }}
            </div>
            <div class="inf-value">
              <div class="inf-value-name">{{ exclusivePackageName }}</div>
              <a
                (click)="routerUpdateOffer()"
                class="link"
                style="
                  font-size: 12px;
                  padding-bottom: 2px;
                  border-bottom: 1px dashed;
                  align-items: end;
                  float: right;
                "
              >
                {{ "home_running.view_detail" | translate }}
              </a>
            </div>
          </div>
          <div class="d-flex" style="margin-top: 12px">
            <div class="inf-title">
              {{ "offers.detail.category" | translate }}
            </div>
            <div class="inf-value" style="text-align: end">
              <div *ngFor="let tag of offerTag">
                <span
                  *ngIf="checkLanguage === 'vn' || checkLanguage == undefined"
                >
                  {{ tag["title_vn"] }}
                </span>
                <span *ngIf="checkLanguage === 'en'">{{ tag["title"] }}</span>
              </div>
            </div>
          </div>
          <div class="d-flex" style="margin-top: 12px">
            <div class="inf-title">
              {{ "offers.detail.type" | translate }}
            </div>
            <div class="inf-value">
              {{ offerType }}
            </div>
          </div>
          <div class="d-flex" style="margin-top: 12px">
            <div class="inf-title">
              {{ "offers.detail.country" | translate }}
            </div>
            <div
              class="inf-value"
              style="text-align: end"
              *ngIf="offerCountries.length > 0"
            >
              <ng-container *ngFor="let country of offerCountries">
                <span>{{ country }}</span>
                <br />
              </ng-container>
            </div>
          </div>
          <div class="d-flex" style="margin-top: 12px">
            <div class="inf-title">
              {{ "offers.tables.tax" | translate }}
            </div>
            <div class="inf-value">
              {{ detailOffer?.is_tax == 1 ? "10.00 %" : "0.00 %" }}
            </div>
          </div>

          <div
            class="border-button"
            style="border: 1px solid #237ce4"
            *ngIf="!disableButtonUpgradeOffer"
          >
            <button
              [style]="{
                width: '100%',
                height: '40px',
                borderRadius: '8px',
                display: 'flex',
                gap: '8px'
              }"
              class="btn btn-primary btn-icon-text"
              (click)="routerUpdateOffer()"
              [disabled]="disableButtonUpgradeOffer"
            >
              {{ "offers.detail.upgrade_offer" | translate }}
              <app-icon-upgrate-offer></app-icon-upgrate-offer>
            </button>
          </div>

          <ng-container *ngIf="checkOfferRequest()">
            <div
              class="border-button"
              [style]="
                checkOfferRequesting()
                  ? 'border: 1px solid rgba(48, 141, 227, 0.65)'
                  : 'border: 1px solid #237CE4'
              "
            >
              <button
                [style]="{
                  width: '100%',
                  height: '40px',
                  borderRadius: '8px',
                  display: 'flex',
                  gap: '8px'
                }"
                class="btn btn-primary btn-icon-text"
                [disabled]="checkOfferRequesting()"
                (click)="handleRequestOffer()"
              >
                <ng-container *ngIf="!checkOfferRequesting(); else requesting">
                  <span>{{ "offers.detail.request_offer" | translate }}</span>
                  <span
                    style="color: #fff; font-size: 17px"
                    class="mdi mdi-invoice-text-send-outline"
                  ></span>
                </ng-container>
                <ng-template #requesting>
                  <span>
                    {{ "offers.detail.request_reviewing" | translate }}
                  </span>
                  <span
                    style="color: #fff; font-size: 17px"
                    class="mdi mdi-invoice-text-clock-outline"
                  ></span>
                </ng-template>
                <ng-container *ngIf="loadRequest">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </ng-container>
              </button>
            </div>

            <div class="content-request">
              <span *ngIf="visibleTypeSelect?.status != 3">
                {{ "offers.detail.request_offer_des" | translate }}
              </span>
              <span *ngIf="visibleTypeSelect?.status == 3">
                {{ "offers.detail.request_contact_am" | translate }}
              </span>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div
        #heightCardLink
        [ngClass]="{
          'card-link-1': checkCardEcommerce,
          'card-link': !checkCardEcommerce && checkOrderApi !== 1,
          'card-link-2': checkOrderApi == 1,
          'card-link-3': detailOffer?.visible_type == 2
        }"
      >
        <app-loading *ngIf="loadHistory || loadDetailPage"></app-loading>
        <ng-container *ngIf="!loadDetailPage && !loadHistory">
          <div class="title">
            {{ "offers.detail.offer_link" | translate }}
          </div>
          <ng-container *ngIf="!checkOfferRequest(); else requestOffer">
            <div class="d-flex" style="margin-top: 12px; align-items: flex-end">
              <div>{{ "offers.detail.landing_page" | translate }}</div>
              <div
                style="margin-left: auto"
                (mouseenter)="onMouseEnter(iconEdit)"
                (mouseleave)="onMouseLeave(iconEdit)"
              >
                <app-button
                  (click)="openScrollableModal(scrollableModal)"
                  #iconEdit
                  [style]="{
                    width: 'auto',
                    borderRadius: '8px',
                    marginLeft: 'auto'
                  }"
                  [class]="'btn btn-outline-primary btn-icon-text'"
                  [text]="'offers.detail.link_edit' | translate"
                  [icon]="'mdi mdi-link-edit'"
                  [iconColor]="'#308DE3'"
                ></app-button>
              </div>
            </div>
            <div
              class="d-flex form-landing-page"
              style="margin-top: 12px; width: 100%; align-items: center"
            >
              <div class="select-landing-page">
                <ng-select
                  (change)="onChaneLandingPage($event)"
                  [items]="landingPages"
                  bindLabel="title"
                  bindValue="id"
                  name="selectStatus"
                  [(ngModel)]="selectedLandingPage"
                  placeholder="Landing Page"
                  [multiple]="false"
                  [clearable]="false"
                  [notFoundText]="'offers.no_data_found' | translate"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.title }}
                  </ng-template>
                </ng-select>
              </div>

              <div class="landing-page-buttons">
                <div
                  ngbTooltip="Copy"
                  class="copy-tracking"
                  [ngClass]="{ disabled: checkTrackingLink }"
                  (click)="!checkTrackingLink ? copyTrackingLink() : null"
                >
                  <app-icon-copy
                    [color]="'#FFFFFF'"
                    [width]="20"
                    [height]="20"
                  ></app-icon-copy>
                </div>
                <div
                  ngbTooltip="Generate QR"
                  class="generate-qr"
                  [ngClass]="{ disabled: checkTrackingLink }"
                  (click)="openModalQr(modalGenerateQr)"
                >
                  <app-icon-qr
                    [color]="'#FFFFFF'"
                    [width]="20"
                    [height]="20"
                  ></app-icon-qr>
                </div>
              </div>
            </div>

            <div
              *ngIf="enableDirectLink && !!directLink"
              class="d-flex"
              style="margin-top: 12px; width: 100%; align-items: center"
            >
              <div style="width: 82%">
                <input
                  type="text"
                  class="form-control col-md-12"
                  disabled
                  [value]="'offers.detail.direct_link' | translate"
                />
              </div>
              <div
                ngbTooltip="Copy"
                class="copy-tracking"
                [ngClass]="{ disabled: checkDirectLink }"
                (click)="enableDirectLink ? copyDirectLink() : null"
              >
                <app-icon-copy
                  [color]="'#FFFFFF'"
                  [width]="20"
                  [height]="20"
                ></app-icon-copy>
              </div>
            </div>

            <div *ngIf="checkOrderApi == 1" style="margin-top: 24px">
              <div style="text-align: start">
                {{ "offers.detail.api_send_order" | translate }}
              </div>
              <div class="field-text-info">
                <app-loading
                  *ngIf="!orderSendApi"
                  [width]="'20px'"
                  [height]="'20px'"
                ></app-loading>
                <ng-container *ngIf="orderSendApi">
                  <div class="text-break">{{ orderSendApi }}</div>
                  <div
                    class="copy"
                    ngbTooltip="Copy"
                    style="padding: 4px; margin-left: auto"
                    (mouseenter)="onMouseEnter(iconCopy)"
                    (mouseleave)="onMouseLeave(iconCopy)"
                    (click)="copyOderSendApi()"
                  >
                    <app-icon-copy #iconCopy></app-icon-copy>
                  </div>
                </ng-container>
              </div>
            </div>

            <div *ngIf="checkCardEcommerce">
              <div style="margin-top: 24px">
                <div style="text-align: start; margin-bottom: 12px">
                  {{ "offers.detail.enter_link_offer" | translate }}
                </div>
                <input
                  [(ngModel)]="valueLink"
                  type="text"
                  class="form-control col-md-12"
                  [placeholder]="'offers.detail.enter_link_offer' | translate"
                />
              </div>

              <app-button
                (click)="createLink()"
                [style]="{
                  width: '100%',
                  height: '40px',
                  borderRadius: '8px',
                  marginTop: '24px'
                }"
                [class]="'btn btn-primary'"
                [text]="'offers.detail.create_link' | translate"
              ></app-button>

              <div style="margin-top: 24px">
                <div style="text-align: start; margin-bottom: 12px">
                  {{ "offers.detail.tracking_link" | translate }}
                </div>
                <div class="field-text-info">
                  <div class="text-break">{{ originalTrackingLink }}</div>
                  <div
                    *ngIf="originalTrackingLink; else noDataTrackingLink"
                    class="copy"
                    ngbTooltip="Copy"
                    style="padding: 4px; margin-left: auto"
                    (mouseenter)="onMouseEnter(iconCopyOriginalLink)"
                    (mouseleave)="onMouseLeave(iconCopyOriginalLink)"
                    (click)="copy(originalTrackingLink)"
                  >
                    <app-icon-copy #iconCopyOriginalLink></app-icon-copy>
                  </div>
                  <ng-template #noDataTrackingLink>
                    <div style="opacity: 0.5">
                      <app-icon-copy></app-icon-copy>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div style="margin-top: 24px">
                <div style="text-align: start; margin-bottom: 12px">
                  {{ "offers.detail.sort_link" | translate }}
                </div>
                <div class="field-text-info">
                  <div class="text-break">{{ sortTrackingLink }}</div>
                  <div
                    *ngIf="sortTrackingLink; else noDataSortTrackingLink"
                    class="copy"
                    ngbTooltip="Copy"
                    style="padding: 4px; margin-left: auto"
                    (mouseenter)="onMouseEnter(iconCopySortLink)"
                    (mouseleave)="onMouseLeave(iconCopySortLink)"
                    (click)="copy(sortTrackingLink)"
                  >
                    <app-icon-copy #iconCopySortLink></app-icon-copy>
                  </div>
                  <ng-template #noDataSortTrackingLink>
                    <div style="opacity: 0.5">
                      <app-icon-copy></app-icon-copy>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #requestOffer>
            <div class="content-request">
              {{ "offers.detail.request_offer_link" | translate }}
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <div [class]="isResponsive ? 'col-md-8' : 'col-md-9'">
      <div class="des-card">
        <div
          [ngClass]="{
            'des-content-ec': checkCardEcommerce,
            'des-content': checkOrderApi == 1,
            'des-content-2': checkOrderApi !== 1
          }"
          class="des-content"
          [style.height]="!isMobile ? heightCardDes : 'auto'"
          [perfectScrollbar]
        >
          <app-loading *ngIf="loadHistory || loadDetailPage"></app-loading>
          <ng-container *ngIf="!loadDetailPage && !loadHistory">
            <div class="title-des">
              {{ "table.info_detail_offer" | translate }}
            </div>
            <ng-container *ngIf="descriptionOb?.length > 0; else noDataDetail">
              <div style="margin-top: 16px">
                <ngb-accordion
                  #acc="ngbAccordion"
                  class="collapse-icon"
                  [activeIds]="activeIds"
                >
                  <ngb-panel
                    *ngFor="let item of descriptionOb; let i = index"
                    id="panel-{{ i }}"
                  >
                    <ng-template ngbPanelTitle>
                      <span class="lead collapse-title">
                        {{ item["key"] }}
                      </span>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div
                        class="html-content"
                        [innerHTML]="item['value']"
                      ></div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>
            </ng-container>
            <ng-template #noDataDetail>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100%;
                "
              >
                <div style="text-align: center">
                  <app-icon-no-data></app-icon-no-data>
                  <div style="font-weight: 600">
                    {{ "table.no_data_detail_offer" | translate }}
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="padding: 0 12px">
  <div
    class="offer-similar row"
    [style]="
      noDataSimilarOffer
        ? 'margin-top: 32px; min-height: 285px;'
        : 'margin-top: 32px;'
    "
  >
    <app-loading *ngIf="loadHistory || loadSimilarOffer"></app-loading>
    <ng-container *ngIf="!loadSimilarOffer && !loadHistory">
      <div
        class="d-flex"
        style="align-items: center; margin-bottom: 16px"
        *ngIf="!noDataSimilarOffer; else viewTitle"
      >
        <div class="title-similar">
          {{ "offers.detail.similar_offer" | translate }}
        </div>
        <div style="margin-left: auto">
          <app-button
            [style]="{ width: 'auto', height: '40px', borderRadius: '8px' }"
            [class]="'btn btn-outline-primary'"
            [text]="'offers.detail.view_all' | translate"
            [routerLink]="['/offers']"
          ></app-button>
        </div>
      </div>
      <ng-template #viewTitle>
        <div class="title-similar">
          {{ "offers.detail.similar_offer" | translate }}
        </div>
      </ng-template>
      <ng-container *ngIf="!noDataSimilarOffer; else noDataSimilar">
        <div
          [ngClass]="isTabView ? 'col-md-6' : 'col-md-3'"
          *ngFor="let item of similarOffers"
        >
          <div
            class="offer-card"
            [style]="isTabView && !isMobile ? 'margin-bottom: 24px' : ''"
          >
            <div class="card-content">
              <div class="d-flex">
                <a
                  (click)="navigateToDetail(item['id'])"
                  class=""
                  style="margin-right: 16px"
                >
                  <img
                    style="height: 80px; width: 80px; border-radius: 8px"
                    src="{{ item['image'] }}"
                  />
                </a>
                <div class="group-name">
                  <span
                    class="offer-name"
                    (click)="navigateToDetail(item['id'])"
                  >
                    {{ item.title }}
                  </span>
                  <div
                    *ngIf="item['tags_selected'].length > 0"
                    class="offer-type"
                    style="width: fit-content; font-size: 14px"
                  >
                    <span
                      *ngIf="
                        checkLanguage === 'vn' || checkLanguage == undefined
                      "
                    >
                      {{
                        item["tags_selected"][0]["title_vn"]
                          ? item["tags_selected"][0]["title_vn"]
                          : item["tags_selected"][0]["title"]
                      }}
                    </span>
                    <span *ngIf="checkLanguage === 'en'">
                      {{ item["tags_selected"][0]["title"] }}
                    </span>
                  </div>
                  <div class="description">
                    {{ item["detail"] }}
                  </div>
                </div>
              </div>

              <div class="more-info">
                <div class="item-info d-flex">
                  <span class="text-commision">
                    {{ "home_running.commission" | translate }}
                  </span>
                  <span style="margin-left: auto; font-weight: 600">
                    <span
                      *ngIf="!checkPayoutSpecial(item)"
                      class="text-commision"
                      style="margin-left: 4px; font-weight: 600"
                    >
                      {{
                        isNumber(getPayout(item))
                          ? (getPayout(item) | commaConvert)
                          : getPayout(item)
                      }}
                    </span>
                    <span
                      *ngIf="checkPayoutSpecial(item)"
                      class="text-commision"
                      style="margin-left: 4px; font-weight: 600"
                    >
                      {{
                        isNumber(payoutRegistered(item))
                          ? (payoutRegistered(item) | commaConvert)
                          : payoutRegistered(item)
                      }}
                    </span>
                  </span>
                </div>
                <div class="item-info-last d-flex">
                  <span class="text-commision">
                    {{ "home_running.ar" | translate }}
                  </span>
                  <div class="text-commision" style="margin-left: auto">
                    <span style="margin-left: 4px; font-weight: 600">
                      {{ item["ar"] | formatNumber: "percent" }}
                    </span>
                  </div>
                </div>
                <div class="item-info-last d-flex">
                  <span class="text-commision">
                    {{ "offers.tables.tax" | translate }}
                  </span>
                  <div class="text-commision" style="margin-left: auto">
                    <span style="margin-left: 4px; font-weight: 600">
                      {{ item["is_tax"] == 1 ? "10.00 %" : "0.00 %" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noDataSimilar>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          "
        >
          <div style="text-align: center">
            <app-icon-no-data></app-icon-no-data>
            <div style="font-weight: 600">
              {{ "table.no_data_table" | translate }}
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>

<qrcode
  #hiddenQrCode
  [qrdata]="qrData"
  [width]="size"
  [errorCorrectionLevel]="level"
  hidden
></qrcode>

<ng-template #modalGenerateQr let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="modal.close('by: close icon')"
      aria-label="Close"
    ></button>
  </div>
  <div id="qrModal" class="modal-qr-body">
    <qrcode
      #qrTrackingLink
      [qrdata]="qrData"
      [width]="size"
      [errorCorrectionLevel]="level"
    ></qrcode>

    <app-button
      #iconDownload
      (click)="downloadQr()"
      [style]="{
        width: 'auto',
        borderRadius: '8px',
        marginLeft: 'auto'
      }"
      [class]="'btn btn-outline-primary btn-icon-text'"
      [text]="'shared.download' | translate"
      [icon]="'mdi mdi-download'"
      [iconColor]="'#308DE3'"
      (mouseenter)="onMouseEnter(iconDownload)"
      (mouseleave)="onMouseLeave(iconDownload)"
    ></app-button>
  </div>
</ng-template>

<ng-template #scrollableModal let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="modal.close('by: close icon')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <div class="title-modal">{{ "offers.detail.edit_link" | translate }}</div>
    <div style="padding-top: 24px">
      <span class="input-title">{{ "offers.detail.offer" | translate }}</span>
      <div class="field-text-info">
        <div class="text-break">
          <span>#</span>
          {{ offerId + " " + offerName }}
        </div>
      </div>
    </div>
    <div style="padding-top: 16px">
      <span class="input-title">
        {{ "offers.detail.landing_page" | translate }}
        <span class="input-title" style="color: #d93a3a">*</span>
      </span>
      <div style="margin-top: 12px">
        <ng-select
          (change)="onChaneLandingPage($event)"
          [items]="landingPages"
          bindLabel="title"
          bindValue="id"
          name="selectStatus"
          [(ngModel)]="selectedLandingPage"
          placeholder="Landing Page"
          [multiple]="false"
          [clearable]="false"
          [notFoundText]="'offers.no_data_found' | translate"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item.title }}
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div style="padding-top: 16px">
      <div class="group-checkbox d-flex">
        <div>
          <input
            [checked]="subIdChecked"
            (click)="handleSubIdCheckbox($event)"
            type="checkbox"
            class="form-check-input"
            id="subId1"
          />
          <label class="title-checkbox" for="subId1">
            {{ "offers.detail.sub_id" | translate }}
          </label>
        </div>
        <div
          [class.disabled]="subIds.length == 5"
          *ngIf="subIdChecked"
          (click)="addSubId()"
          class="d-flex"
          [style]="
            subIds.length !== 5
              ? 'margin-left: auto; cursor: pointer'
              : 'margin-left: auto; opacity: 0.5;'
          "
        >
          <span
            style="color: #308de3"
            class="mdi mdi-plus-box-multiple-outline"
          ></span>
          <div style="color: #308de3; margin-left: 4px">
            {{ "offers.detail.add_sub_id" | translate }}
          </div>
        </div>
      </div>
      <div style="margin-top: -8px" class="row">
        <div
          class="col-md-6"
          style="margin-top: 8px"
          *ngFor="let subId of subIds; let i = index"
        >
          <input
            [disabled]="!subIdChecked"
            id="inputSub{{ i + 1 }}"
            [(ngModel)]="subId.value"
            (ngModelChange)="keyUpAddSubId()"
            type="text"
            class="form-control col-md-6"
            [placeholder]="subId.title"
          />
        </div>
      </div>
    </div>
    <div style="padding-top: 16px">
      <div class="group-checkbox d-flex">
        <div>
          <input
            [checked]="affClickIdChecked"
            (click)="handleAffClickCheckbox($event)"
            type="checkbox"
            class="form-check-input"
          />
          <label class="title-checkbox">
            {{ "offers.detail.aff_click_id" | translate }}
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input
            [disabled]="!affClickIdChecked"
            [(ngModel)]="affClickId.value"
            (ngModelChange)="changeTrackingLink()"
            type="text"
            class="form-control col-md-6"
            [placeholder]="affClickId.title"
          />
        </div>
      </div>
    </div>
    <div style="padding-top: 16px">
      <div class="group-checkbox d-flex">
        <div>
          <input
            [checked]="mobileParamsChecked"
            (click)="handleMobileParamsCheckbox($event)"
            type="checkbox"
            class="form-check-input"
          />
          <label class="title-checkbox">
            {{ "offers.detail.mobile_param" | translate }}
          </label>
        </div>
      </div>
      <div class="row">
        <div
          [style]="isMobile ? 'margin-bottom: 8px' : ''"
          class="col-md-6"
          *ngFor="let mobileParam of mobileParams"
        >
          <input
            [disabled]="!mobileParamsChecked"
            [(ngModel)]="mobileParam.value"
            (ngModelChange)="keyUpMobileParams()"
            type="text"
            class="form-control col-md-6"
            [placeholder]="mobileParam.title"
          />
        </div>
      </div>
    </div>
    <div
      [style]="isMobile ? 'margin-top: 8px' : 'margin-top: 16px'"
      class="group-tracking-link"
    >
      <div>
        <div style="text-align: start; font-weight: 600">
          {{ "offers.detail.tracking_link" | translate }}
        </div>
        <div class="field-text-info">
          <div class="text-break">{{ trackingLinkFull }}</div>
          <div
            class="copy"
            ngbTooltip="Copy"
            style="padding: 4px; margin-left: auto"
            (mouseenter)="onMouseEnter(iconCopy)"
            (mouseleave)="onMouseLeave(iconCopy)"
            (click)="copyTrackingLink()"
          >
            <app-icon-copy #iconCopy></app-icon-copy>
          </div>
        </div>
      </div>
      <div *ngIf="enableDirectLink && !!directLink" style="margin-top: 16px">
        <div style="text-align: start; font-weight: 600">
          {{ "offers.detail.direct_link" | translate }}
        </div>
        <div class="field-text-info">
          <div class="text-break white-space">{{ directLink }}</div>
          <div
            class="copy"
            ngbTooltip="Copy"
            style="padding: 4px; margin-left: auto"
            (mouseenter)="onMouseEnter(iconCopy)"
            (mouseleave)="onMouseLeave(iconCopy)"
            (click)="copyDirectLink()"
          >
            <app-icon-copy #iconCopy></app-icon-copy>
          </div>
        </div>
      </div>
      <div style="margin-top: 16px">
        <div style="text-align: start; font-weight: 600">
          {{ "offers.detail.impression_pixel" | translate }}
        </div>
        <div class="field-text-info">
          <div class="text-break">{{ impressionsPixel }}</div>
          <div
            class="copy"
            ngbTooltip="Copy"
            style="padding: 4px; margin-left: auto"
            (mouseenter)="onMouseEnter(iconCopyPixel)"
            (mouseleave)="onMouseLeave(iconCopyPixel)"
            (click)="copyImpressons()"
          >
            <app-icon-copy #iconCopyPixel></app-icon-copy>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex" style="margin-top: 24px; justify-content: center">
      <div style="margin-right: 12px">
        <app-button
          (click)="modal.close('by: close button')"
          [style]="{ width: '160px', borderRadius: '8px' }"
          [class]="'btn btn-outline-primary'"
          [text]="'offers.detail.close' | translate"
        ></app-button>
      </div>

      <div style="margin-left: 12px">
        <app-button
          (click)="modal.close('by: save button')"
          [style]="{ width: '160px', borderRadius: '8px' }"
          [class]="'btn btn-primary'"
          [text]="'offers.detail.save' | translate"
        ></app-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalUpgrade let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="modal.close('by: close icon')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body-upgrade">
    <div class="d-flex" style="justify-content: center">
      <app-icon-upgrade-md></app-icon-upgrade-md>
    </div>
    <div style="margin-top: 24px; text-align: center; font-size: 16px">
      {{ "offers.upgrade.content_modal" | translate }}
    </div>

    <div class="d-flex" style="margin-top: 24px; justify-content: center">
      <div [style]="{ marginRight: '12px', width: isMobile ? '100%' : '' }">
        <app-button
          (click)="modal.close('by: close button')"
          [style]="{ width: isMobile ? '100%' : '160px', borderRadius: '8px' }"
          [class]="'btn btn-outline-primary'"
          [text]="'offers.upgrade.later' | translate"
        ></app-button>
      </div>

      <div [style]="{ marginLeft: '12px', width: isMobile ? '100%' : '' }">
        <app-button
          (click)="routerUpdateOffer()"
          [style]="{ width: isMobile ? '100%' : '160px', borderRadius: '8px' }"
          [class]="'btn btn-primary'"
          [text]="'offers.upgrade.upgrade_btn' | translate"
        ></app-button>
      </div>
    </div>
  </div>
</ng-template>
